export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_agency-portfolio-70/artifacts/lf6b4djo_LOGO%20PRESSURE%20WASHER%202026.png";

export const BRAND = {
    name: "STRONGER SOLUTIONS",
    owner: "Jefferson",
    phoneDisplay: "(404) 483-4441",
    phoneRaw: "4044834441",
    whatsapp: "14044834441",
    whatsappMessage:
        "Hi Jefferson! I saw your website and would like a free quote for cleaning services.",
    location: "Georgia & Surrounding Areas",
    taglinePrimary: "STRONGER CLEANING.",
    taglineSecondary: "STRONGER RESULTS.",
    taglineScript: "Stronger Solutions For A Cleaner Tomorrow.",
    promise: "We Restore. We Protect. We Deliver.",
};

export const telHref = `tel:+1${BRAND.phoneRaw}`;
export const waHref = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
    BRAND.whatsappMessage
)}`;
